var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilesUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-files-unselected_svg__clip0_1837_6490)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.212 1.43l3.024 3.025a.333.333 0 01.098.235v9.643c0 .184-.15.334-.334.334H3a.333.333 0 01-.333-.334V1.667c0-.184.15-.334.333-.334h6.977c.088 0 .173.035.235.098zM10.391 0H2.667C1.93 0 1.334.597 1.334 1.333v13.334c0 .736.596 1.333 1.333 1.333h10.666c.737 0 1.334-.597 1.334-1.333V4.276a.667.667 0 00-.195-.471l-3.61-3.61A.667.667 0 0010.391 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.667 7.333h-6a.667.667 0 110-1.333h6a.667.667 0 010 1.333zM10.667 10h-6a.667.667 0 010-1.333h6a.667.667 0 110 1.333zM7.667 12.667h-3a.667.667 0 010-1.334h3a.667.667 0 010 1.334z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-files-unselected_svg__clip0_1837_6490"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgIconFilesUnselected;